import { render, staticRenderFns } from "./IdiUniversity.html?vue&type=template&id=1a06e188&scoped=true&"
import script from "./IdiUniversity.vue?vue&type=script&lang=js&"
export * from "./IdiUniversity.vue?vue&type=script&lang=js&"
import style0 from "./IdiUniversity.scss?vue&type=style&index=0&id=1a06e188&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a06e188",
  null
  
)

export default component.exports